// extracted by mini-css-extract-plugin
module.exports = {"statusDot":"styles_statusDot__27tzB","active":"styles_active__2gI81"};